import api from './api'

/** Self-service account actions for the logged-in user (no F-module permission needed). */
export const profileService = {
  async get() {
    const { data } = await api.get('/me')
    return data.data
  },

  /** fields: { name, phone, gender, date_of_birth, address } (empty string clears) */
  async update(fields) {
    const { data } = await api.put('/me', fields)
    return data.data
  },

  async uploadAvatar(file) {
    const form = new FormData()
    form.append('file', file)
    const { data } = await api.post('/me/avatar', form, { headers: { 'Content-Type': 'multipart/form-data' } })
    return data.data
  },

  async changePassword({ currentPassword, newPassword }) {
    await api.post('/me/password', { current_password: currentPassword, new_password: newPassword })
  }
}
